import type { LayoutPageConfig } from './types';

export const accountSettingsPageConfig = {
  namespacesRequired: ['settings', 'eula'],
  layout: {
    showHeaderPeriodFilter: false,
  },
} satisfies LayoutPageConfig;
